package one.healthium.base.utils

import loco.GENERAL_CALORIES_FORMAT
import loco.GENERAL_WEIGHT_GRAM_FORMAT
import loco.GENERAL_WEIGHT_KG_FORMAT
import loco.GENERAL_WEIGHT_LB_FORMAT
import one.healthium.loco.LString
import one.healthium.loco.asLString
import kotlin.math.roundToInt

object Formatters {
    fun Float?.formatCalories(addUnit: Boolean = true, roundToK: Boolean = false): LString {
        val value = if (this == null) {
            "0"
        } else if (roundToK && this >= 10000) {
            "${this.roundToInt() / 1000}k"
        } else {
            this.roundToInt().toString()
        }

        return if (addUnit) {
            loco.Res.string.GENERAL_CALORIES_FORMAT.asLString(value)
        } else {
            value.asLString()
        }
    }

    fun Float?.formatCalories2(addUnit: Boolean = true, roundToK: Boolean = false): String {
        val value = if (this == null) {
            "0"
        } else if (roundToK && this >= 10000) {
            "${this.roundToInt() / 1000}k"
        } else {
            this.roundToInt().toString()
        }

        return if (addUnit) {
            "$value cal" // TODO loco
        } else {
            value
        }
    }

    fun Float.formatWeight(isMetric: Boolean): LString {
        val value = ((if (isMetric) this else this.kgToLb())).toString(1)
        return if (isMetric) {
            loco.Res.string.GENERAL_WEIGHT_KG_FORMAT.asLString(value)
        } else {
            loco.Res.string.GENERAL_WEIGHT_LB_FORMAT.asLString(value)
        }
    }

    fun Float.formatGrams(): LString {
        return loco.Res.string.GENERAL_WEIGHT_GRAM_FORMAT.asLString(this.toString(2))
    }
}